import { FC } from 'react'
import styled, { withTheme } from 'styled-components'
import { Campaign as CampaignModel } from '@/network/graphql.g'
import Link from '@/components/atoms/link'
import ResponsiveImage from '@/components/atoms/responsiveImageNew'
import { MHubBannerProps } from '@/providers/mhub/useMhubTrackBanner'
import { useTrackBanners } from 'hooks/useTrackBanners'
import { BannerDescriptionType, BannerPageLocationType } from '../bannersLayout'

type HomeBannersProps = {
  campaign: CampaignModel
} & Rest

const HomePageCampaigns: FC<HomeBannersProps> = ({ campaign, ...rest }) => {
  const trackBanner: MHubBannerProps = {
    id: campaign.id + '_campaign',
    title: campaign?.title,
    primaryUrl: campaign.url,
    imgSrc: campaign.desktopImage,
    sortOrder: rest.sortOrder,
    description: BannerDescriptionType.Campaign,
    page: BannerPageLocationType.Home
  }
  const { observe, pushShowBanners } = useTrackBanners(trackBanner)
  const setTrackBanner = () => {
    pushShowBanners(trackBanner)
  }

  return (
    <div ref={observe} onClick={setTrackBanner}>
      <Link key={campaign.id} href={campaign.url}>
        <StyledResponsiveImage
          width={600}
          height={280}
          imageUrl={campaign.desktopImage}
        />
      </Link>
    </div>
  )
}

export default withTheme(HomePageCampaigns)

const StyledResponsiveImage = styled(ResponsiveImage)`
  border-radius: ${(props) => props.theme.borderRadius}px;
`
